define('frontend-common-components/gettingStartedPanel/nls/gettingStartedPanel',{
    'root': true
});
